import { render, staticRenderFns } from "./PartnerBrandList.vue?vue&type=template&id=536d4342&"
import script from "./PartnerBrandList.vue?vue&type=script&lang=js&"
export * from "./PartnerBrandList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports